import { createRoute } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';
import paths from '../../../paths';
import { MemoryBankNotesListingPage } from './MemoryBankNotesListingPage';

export const Route = createRoute({
  path: paths.authenticated.memoryBankNotes,
  getParentRoute: () => pathlessAuthenticatedRoute,
  component: MemoryBankNotesListingPage,
});
